/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../common/common';
import '../common/async_transaction_common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "CompleteAsyncTransactionRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "thirdPartyTerminalDetails": {
                    "type": ".squareup.esperanto.api.ThirdPartyTerminalTransactionDetails",
                    "id": 4
                  },
                  "multiBrandTransactionDetails": {
                    "type": ".squareup.esperanto.common.AsyncMultiBrandTransactionDetails",
                    "id": 5
                  }
                },
                "nested": {
                  "complete_async_transaction_details": {
                    "oneof": ["thirdPartyTerminalDetails", "multiBrandTransactionDetails"]
                  }
                }
              },
              "CompleteAsyncTransactionResponse": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.esperanto.api.CompleteAsyncTransactionResponse.CompleteAsyncTransactionError",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CompleteAsyncTransactionError": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INVALID_STATE": 1,
                      "RECORD_NOT_FOUND": 2,
                      "INVALID_TRANSACTION_TYPE": 3
                    }
                  }
                }
              },
              "ThirdPartyTerminalTransactionDetails": {
                "fields": {
                  "last4": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardType": {
                    "type": ".squareup.esperanto.common.CardType",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CompleteAsyncTransactionRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CompleteAsyncTransactionResponse && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CompleteAsyncTransactionResponse?.nested?.CompleteAsyncTransactionError && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.ThirdPartyTerminalTransactionDetails) {
  $root.addJSON(jsonData);
}

/**
 * Request payload for completing a submitted async transaction.
 *
 * SOURCE CompleteAsyncTransactionRequest @ squareup/esperanto/api/complete_async_transaction.proto at 15:1
 */
export const CompleteAsyncTransactionRequest = $root.lookupType('squareup.esperanto.api.CompleteAsyncTransactionRequest');
fixType(CompleteAsyncTransactionRequest, {
  paymentId: {
    required: true
  }
});
Builder.createAndAttachToType(CompleteAsyncTransactionRequest);
/**
 * Response payload for completing a submitted async transaction.
 * The resulting AsyncTransactionStatus should be COMPLETED.
 *
 * SOURCE CompleteAsyncTransactionResponse @ squareup/esperanto/api/complete_async_transaction.proto at 40:1
 */
export const CompleteAsyncTransactionResponse = $root.lookupType('squareup.esperanto.api.CompleteAsyncTransactionResponse');
fixType(CompleteAsyncTransactionResponse, {
  paymentId: {
    required: true
  }
});
Builder.createAndAttachToType(CompleteAsyncTransactionResponse);
/**
 * Error types for CompleteAsyncTransaction
 *
 * SOURCE CompleteAsyncTransactionError @ squareup/esperanto/api/complete_async_transaction.proto at 46:3
 */
CompleteAsyncTransactionResponse.CompleteAsyncTransactionError = $root.lookupEnum('squareup.esperanto.api.CompleteAsyncTransactionResponse.CompleteAsyncTransactionError').values;
/**
 * SOURCE ThirdPartyTerminalTransactionDetails @ squareup/esperanto/api/complete_async_transaction.proto at 55:1
 */
export const ThirdPartyTerminalTransactionDetails = $root.lookupType('squareup.esperanto.api.ThirdPartyTerminalTransactionDetails');
fixType(ThirdPartyTerminalTransactionDetails);
Builder.createAndAttachToType(ThirdPartyTerminalTransactionDetails);